<template>
    <div>

        <b-row v-if="false" class="match-height">
            <b-col lg="2" cols="6">
                <card-statistic-order-chart />
            </b-col>
            <b-col lg="2" cols="6">
                <card-statistic-profit-chart />
            </b-col>
            <b-col lg="8" cols="12">
                <card-statistics-group />
            </b-col>
        </b-row>

        <b-row v-if="false" class="match-height">
            <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical icon="EyeIcon"
                                         statistic="36.9k"
                                         statistic-title="Views"
                                         color="info" />
            </b-col>
            <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical color="warning"
                                         icon="MessageSquareIcon"
                                         statistic="12k"
                                         statistic-title="Comments" />
            </b-col>
            <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical color="danger"
                                         icon="ShoppingBagIcon"
                                         statistic="97.8k"
                                         statistic-title="Orders" />
            </b-col>
            <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical color="primary"
                                         icon="HeartIcon"
                                         statistic="26.8"
                                         statistic-title="Favorited" />
            </b-col>
            <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical color="success"
                                         icon="AwardIcon"
                                         statistic="689"
                                         statistic-title="Reviews" />
            </b-col>
            <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical hide-chart
                                         color="danger"
                                         icon="TruckIcon"
                                         statistic="2.1k"
                                         statistic-title="Returns" />
            </b-col>
        </b-row>


    </div>

</template>


<script>
    import CardStatisticOrderChart from './demo/CardStatisticOrderChart.vue'
    import CardStatisticProfitChart from './demo/CardStatisticProfitChart.vue'
    import CardStatisticsGroup from './demo/CardStatisticsGroup.vue'

    import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
    import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
    import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
    import StatisticCardWithLineChart from '@core/components/statistics-cards/StatisticCardWithLineChart.vue'


    export default {
        components: { CardStatisticOrderChart, CardStatisticProfitChart, CardStatisticsGroup, StatisticCardVertical },
        data: () => ({
            tester: "",
            tester2: "",
        }),
        computed: {},
        created() { },
        mounted() { },
        methods: {},
    }
</script>
